import { type CSSProperties } from 'react';

import { type ToastPlacement } from './ToastItem';

type GetToastListStyleParams = {
  bottomOffset: number;
  container: HTMLElement | null | undefined;
  placement: ToastPlacement;
  toastRightOffset: number | string;
  toastXOffset: number | string;
};

export const getToastListStyle = ({
  bottomOffset,
  container,
  placement,
  toastRightOffset,
  toastXOffset,
}: GetToastListStyleParams): CSSProperties | undefined => {
  const isTop = placement === 'top';

  if (container) {
    if (isTop) {
      return { left: toastXOffset || undefined, right: toastRightOffset || undefined };
    }

    return { bottom: bottomOffset || undefined, left: toastXOffset || undefined, right: toastRightOffset || undefined };
  }

  if (isTop) {
    return { left: toastXOffset, right: toastRightOffset };
  }

  return {
    left: toastXOffset,
    marginBottom: bottomOffset,
    right: toastRightOffset,
  };
};
